export default {
      id: "icon-plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-plus",
      toString: function () {
        return this.url;
      }
    }